import React, { useEffect, useMemo, useState, useRef, createContext, useContext } from "react";
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import DataGrid, { SelectColumn, useRowSelection } from 'react-data-grid';
import 'react-data-grid/lib/styles.css';
//import { CellExpanderFormatter } from './cellexpanderformatter';
import moment from "moment";
import { Badge, Box, Typography, IconButton, Tooltip, Checkbox, ListItem, Card, CardContent } from "@mui/material";
import { EditOutlined } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import Helper from "../../../utility/helper";

const GRID_ROW_HEIGHT = 90;
const GRID_HEADER_ROW_HEIGHT = 40;

const theme = createTheme();

const useStyles = makeStyles(() => ({
    cellExpandClassname: {
        float: 'right',
        float: 'inline-end',
        display: 'table',
        blockSize: '100%',
        "& span": {
            display: 'table-cell',
            verticalAlign: 'middle',
            cursor: 'pointer'
        }
    },
    enablesTextWrapping: {
        display: 'inline-block',
        lineHeight: 1.5,
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        textAlign: 'justify'
    },
    addPad: {
        padding: theme.spacing(2),
    },
    addHeader: {
        backgroundColor: "#17408B",
        color: 'white'
    },
    noHeaderWrapper: {
        '& .rdg-header-row': {
            display: 'none'
        }
    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'white',
        padding: '10px 0',
        cursor: 'pointer',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    container: {
        '& .rdg-header-row': {
            '& .rdg-cell': {
                zIndex: 10
            },
        },
        '& .rdg-cell': {
            zIndex: 1,
        },
        display: 'flex',
        flexDirection: 'column',
        blockSize: '75vh',
        gap: '10px',
        '&> .rdg': {
            flex: 1
        }
    },

}));
const userInfo = Helper.getStorage('userInfo');
const endUser = false;

const ScheduleDataGrid = (props) => {
    const classes = useStyles();
    const [activityData, setActivityData] = useState([]);

    useEffect(() => {

        if (props.data && props.data.length > 0) {
            setActivityData(props.data);
        }

        else {
            setActivityData([]);
        }
    }, [props.data])

    let compareTwoArrayOfObjects = (
        first_array_of_objects,
        second_array_of_objects
    ) => {
        return (
            first_array_of_objects.length === second_array_of_objects.length &&
            first_array_of_objects.every((element_1) =>
                second_array_of_objects.some((element_2) =>
                    Object.keys(element_1).every((key) => element_1[key] === element_2[key])
                )
            )
        );
    };

    const onCheckSelect = (event, row) => {
        props.onCheckSelect(event, row);
    }

    const activityColumns = useMemo(() => {

        let column = [

            {
                key: "activityDate",
                name: "Activity Date",
                width: props.showUserActivity ? '10%' : '8%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.startDateTime !== null
                        ? moment(item.startDateTime).format('MM/DD/YYYY') : ''
                },
            },
            {
                key: "startDateTime",
                name: "Start Time",
                width: props.showUserActivity ? '10%' : '7%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.startDateTime !== null
                        ? moment(item.startDateTime).format(
                            'hh:mm A'
                        ) : ''
                }
            },
            {
                key: "endDateTime",
                name: "End Time",
                width: props.showUserActivity ? '10%' : '7%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.endDateTime !== null
                        ? moment(item.endDateTime).format(
                            'hh:mm A'
                        ) : ''
                },
            },
            {
                key: "activityName",
                name: "Activity",
                width: props.showUserActivity ? '18%' : '17%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box sx={{ position: 'relative', top: '50%', transform: 'translateY(-50%)' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={600}>{item.activityName}</Typography>
                            {item.notes ?
                                <Tooltip title={item.notes}>
                                    <div style={{ overflow: "hidden", textOverflow: "ellipsis", width: props.showUserActivity ? '10rem' : '13rem' }}>
                                        <Typography
                                            fontSize={11}
                                            noWrap
                                        // sx={{
                                        //     wordBreak: 'break-word',
                                        //     fontWeight: 'bold'
                                        // }}
                                        >
                                            Notes: {item.notes}
                                        </Typography>
                                    </div>
                                </Tooltip>
                                : null}
                        </Box>
                    )
                }
            },
            {
                key: "attire",
                name: "Attire",
                width: '10%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            {item.attire}
                        </Box>
                    )
                }
            },
            {
                key: "location",
                name: "Location",
                width: props.showUserActivity ? '16%' : '14%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Tooltip title={item.location} aria-label={item.location}>{item.location}</Tooltip>
                        </Box>
                    )
                }
            },
            {
                key: "participants",
                name: "Participants",
                width: props.showUserActivity ? '20%' : '18%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.participants.map((vals, index) => {
                        const splitD = vals.participant.replace(',', '').split(' ')
                        if (item.participants.length > 4) {
                            return (
                                <React.Fragment key={`pSubActivity_${index}`}>
                                    <Typography
                                        fontSize={11}
                                        key={vals.userID}
                                        component="span"
                                        title={vals.participant}
                                        sx={{
                                            marginRight: '2px',
                                            cursor: 'pointer',
                                            fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                        }}>
                                        {(splitD[2] !== undefined ? splitD[2].charAt(0).toUpperCase() : '') + splitD[1].charAt(0).toUpperCase() + '' + splitD[0].charAt(0).toUpperCase() + '' + (item.participants.length !== (index + 1) ? ', ' : '')}

                                    </Typography>
                                </React.Fragment>
                            )
                        } else {
                            return (
                                <React.Fragment key={`pSubActivity_${index}`}>
                                    <Typography
                                        fontSize={11}
                                        key={vals.userID}
                                        component="span"
                                        title={vals.participant}
                                        sx={{
                                            marginRight: '2px',
                                            cursor: 'pointer',
                                            fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                        }}>
                                        {vals.participant.replace(',', ' ') + (item.participants.length !== (index + 1) ? ', ' : '')}
                                    </Typography>
                                </React.Fragment>
                            )
                        }
                    })
                }
            },
            {
                key: "isRowPublished",
                name: !props.showUserActivity ? "Action" : "",
                width: props.showUserActivity ? '6%' : '14%',
                // cellClass(row) {
                //     return classes.enablesTextWrapping
                // },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        // <Box sx={{
                        //     display: 'flex', alignItems: 'center', justifyContent: 'center'
                        // }}>
                        <>
                            {item.isRowPublished ? (
                                <IconButton>
                                    <CheckCircleIcon
                                        fontSize="small"
                                        style={{ color: '#008000' }}
                                    />
                                </IconButton>
                            ) : (
                                <IconButton>
                                    <UnpublishedIcon
                                        fontSize="small"
                                        style={{ color: '#FF5733' }}
                                    />
                                </IconButton>
                            )
                            }

                            {!props.showUserActivity ?
                                <>
                                    <Tooltip title="Add Participants" aria-label="add-participants">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                //saveGridScrollPosition(row);
                                                props.handleAddParticipants(row);

                                            }}
                                        >
                                            <GroupAddIcon
                                                fontSize="small"
                                                color={'primary'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="View Participants" aria-label="view-participants">
                                        <IconButton
                                            color="primary"
                                            onClick={() => props.handleViewParticipants(row)}
                                        >
                                            <Badge badgeContent={item.participants && item.participants.length > 0 ? item.participants.length : 0} color="primary">
                                                <PeopleAltIcon
                                                    fontSize="small"
                                                    color={'primary'}
                                                />
                                            </Badge>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Edit" aria-label="edit">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                props.editRow(row);
                                                // saveGridScrollPosition(row);
                                            }}>
                                            <EditOutlined
                                                fontSize="small"
                                                color={'primary'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </>
                                : null}
                        </>
                        // </Box>
                    )
                }
            }
        ];
        if (!props.showUserActivity) {
            column.unshift({
                key: 'activityID',
                name: '',
                width: '5%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        !props.showUserActivity ?
                            <Checkbox
                                inputProps={{
                                    'aria-label': 'Participant',
                                }}
                                checked={row.selected ? row.selected : false}
                                onChange={(event) => onCheckSelect(event, row)}
                                //value={actData.activityID}
                                sx={{ marginLeft: theme.spacing(0.75) }}
                            />
                            : null
                    )
                }
            })
        }

        return column;
    }, [activityData]);


    function rowHeight() {
        // should be based on the content of the row
        //return 40 + Math.round(Math.random() * 50);
        return 50 + Math.round(3 * 50);
    }

    return (
        <Box className={classes.container} >

            {props.data && props.data.length > 0 ?
                <>
                    <DataGrid
                        rowKeyGetter={rowKeyGetter}
                        columns={activityColumns}
                        rows={activityData}
                        rowHeight={GRID_ROW_HEIGHT}//{rowHeight}
                        className={'fill-grid'}
                        //enableVirtualization
                        headerRowHeight={GRID_HEADER_ROW_HEIGHT}
                        direction={props.direction}
                        defaultColumnOptions={{ resizable: false }}

                    />
                </>
                : <ListItem className={classes.listItemContent}>
                    <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>
                </ListItem>
            }
        </Box>
    )
}

export default ScheduleDataGrid;


function rowKeyGetter(row) {
    const id = row.actualData.activityID;
    return id;
}
